import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
  scmAuthApiRef,
} from '@backstage/integration-react';
import {
  configApiRef,
  discoveryApiRef,
  identityApiRef,
  analyticsApiRef,
  microsoftAuthApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  GrpcDocsClient,
  grpcDocsApiRef,
} from '@samuel.fabel/plugin-grpc-docs';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { TechRadarClient } from '../../lib/techRadarAPI';
import { UmamiAnalytics } from '@axis-backstage/plugin-analytics-module-umami';


const scmIntegrationsApi = ApiBlueprint.make({
  name: 'scm-integrations',
  params: defineParams =>
    defineParams({
      api: scmIntegrationsApiRef,
      deps: { configApi: configApiRef },
      factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
    }),
});

const scmAuthApi = ApiBlueprint.make({
  name: 'scm-auth',
  params: defineParams =>
    defineParams({
      api: scmAuthApiRef,
      deps: { microsoftAuthApi: microsoftAuthApiRef },
      factory: ({ microsoftAuthApi }) => ScmAuth.forAzure(microsoftAuthApi),
    }),
});

const techRadarApi = ApiBlueprint.make({
  name: 'tech-radar',
  params: defineParams =>
    defineParams({
      api: techRadarApiRef,
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) =>
        new TechRadarClient(configApi, identityApi),
    }),
});

const analyticsApi = ApiBlueprint.make({
  name: 'analytics',
  params: defineParams =>
    defineParams({
      api: analyticsApiRef,
      deps: { configApi: configApiRef, fetchApi: fetchApiRef },
      factory: ({ configApi, fetchApi }) =>
        UmamiAnalytics.fromConfig(configApi, { fetchApi }),
    }),
});

/** Registers the gRPC docs client used by the composed API Docs widget. */
const grpcDocsApi = ApiBlueprint.make({
  name: 'grpc-docs',
  params: defineParams =>
    defineParams({
      api: grpcDocsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new GrpcDocsClient({ discoveryApi, fetchApi, identityApi }),
    }),
});

export const apisModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    scmIntegrationsApi,
    scmAuthApi,
    analyticsApi,
    grpcDocsApi,
  ],
});

// Override the NFS tech-radar plugin's built-in API with our custom client
export const techRadarApiModule = createFrontendModule({
  pluginId: 'tech-radar',
  extensions: [techRadarApi],
});
